import React, { useEffect, useRef } from 'react';
import Breadcrumb from '../../../Breadcrumb/Breadcrumb';

const SpaceAssetsModalBreadcrumb = (props) => {
  const { breadcrumbItems, shouldDisabled } = props;
  const breadCrumbRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!breadCrumbRef.current) return;

    const addRemoveDisableClass = (selector: string) => {
      const ele = breadCrumbRef.current!.querySelector(selector);
      if (ele) {
        ele.classList.toggle('SpaceAssetsModal--disabled', shouldDisabled);
      }
    };

    addRemoveDisableClass('.Breadcrumb--v2');
  }, [shouldDisabled]);

  return (
    <div className="SpaceAssetsModalBreadcrumb" ref={breadCrumbRef}>
      <Breadcrumb testId={'am-v2-space-assets-breadcrumb'} version="v2" breadcrumbItems={breadcrumbItems} isResponsive="truncate" />
    </div>
  );
};

export default SpaceAssetsModalBreadcrumb;
